import React from "react";
function ModalDeliveryReturn(){
    return(
        <>
            {/* <!-- modal delivery_return --> */}
    <div class="modal modalCentered fade modalDemo tf-product-modal modal-part-content" id="delivery_return">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="header">
                    <div class="demo-title">Shipping & Delivery</div>
                    <span class="icon-close icon-close-popup" data-bs-dismiss="modal"></span>
                </div>
                <div class="overflow-y-auto">
                    <div class="tf-product-popup-delivery">
                        <div class="title">Delivery</div>
                        <p class="text-paragraph">All orders shipped with UPS Express.</p>
                        <p class="text-paragraph">Always free shipping for orders over US $250.</p>
                        <p class="text-paragraph">All orders are shipped with a UPS tracking number.</p>
                    </div>
                    <div class="tf-product-popup-delivery">
                        <div class="title">Returns</div>
                        <p class="text-paragraph">Items returned within 14 days of their original shipment date in same
                            as new condition will be eligible for a full refund or store credit.</p>
                        <p class="text-paragraph">Refunds will be charged back to the original form of payment used for
                            purchase.</p>
                        <p class="text-paragraph">Customer is responsible for shipping charges when making returns and
                            shipping/handling fees of original purchase is non-refundable.</p>
                        <p class="text-paragraph">All sale items are final purchases.</p>
                    </div>
                    <div class="tf-product-popup-delivery">
                        <div class="title">Help</div>
                        <p class="text-paragraph">Give us a shout if you have any other questions and/or concerns.</p>
                        <p class="text-paragraph">Email: <a href="mailto:contact@domain.com"
                                aria-describedby="a11y-external-message"><span
                                    class="__cf_email__">contact@domain.com</span></a></p>
                        <p class="text-paragraph mb-0">Phone: +1 (23) 456 789</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- /modal delivery_return --> */}

        </>
    )
}
export default ModalDeliveryReturn;